import 'range-slider-element';
import debounce from 'lodash/debounce';

/**
 * Budget Slider
 */
export class BudgetSliderController
{
    constructor(core, $container) {
        this.core = core

        this.setContainerElement($container)
    }
    
    setContainerElement(containerEl) {
        this.containerEl  = containerEl

        this.rangeEl = this.containerEl.querySelector('range-slider')

        this.parentEl = this.containerEl.closest('.et_pb_column')

        this.listenForChange(this.rangeEl)

        return this
    }

    listenForChange(el) {

        el.addEventListener('input',  () => {
            this.setPrice()
        })

        el.addEventListener('input',  debounce(e => {
            this.fireChanged(
                el.value
            )
        }, 500))
    }

    fireChanged(max_budget) {
        this.changeCallback.call(null, max_budget)
    }

    change(callback) {
        this.changeCallback = callback
    }

    enable() {
        this.rangeEl.removeAttribute('disabled')
    }

    disable() {
        this.rangeEl.setAttribute('disabled', 'disabled')
    }

    setPrice() {
        this.parentEl.querySelectorAll('.budget-amount').forEach($e => {
            $e.innerHTML = this.rangeEl.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        })
    }

    render(from, to, searchParams) {
        if (searchParams.price_to) {
            this.rangeEl.value = searchParams.price_to
        }

        for (const n of this.parentEl.querySelectorAll(".et_pb_text_inner *")) {
            if (n.tagName !== 'SCRIPT' && n.innerHTML.match("{{ budget_slider_amount }}")) {
                n.innerHTML = n.innerHTML.replace("{{ budget_slider_amount }}", '<span class="budget-amount">00,000</span>')
            }
        }

        this.setPrice()

        this.enable()
    }
}